module.exports = __webpack_public_path__ + "static/media/driveicon.fe2402b2.png";